import { z } from "zod";
export const mailingAddressSchema = z.object({
    name: z.string().optional(),
    addressStreet: z.string(),
    addressStreet2: z.string().optional(),
    addressCity: z.string(),
    addressRegion: z.string(),
    addressPostalCode: z.string(),
});
export const LogoStatusReasons = {
    MISSING: "Missing",
    DOES_NOT_MATCH_BRAND: "Does not match brand",
    IS_NOT_LEGIBLE: "Not legible",
    TAGLINE_NEEDS_TO_BE_REMOVED: "Tagline needs to be removed",
    CONTACT_INFO_NEEDS_TO_BE_REMOVED: "Contact information needs to be removed",
    IT_IS_TOO_SMALL_OR_NOT_LEGIBLE: "It is too small or not legible",
    BACKGROUND_NEEDS_TO_BE_REMOVED: "Background needs to be removed",
};
export const modelDescriptionSchema = z.object({
    description: z.string(),
    goods_and_services: z.array(z.string()),
});
export const goodsAndServicesSchema = {
    name: "goods_and_services_schema",
    strict: true,
    schema: {
        type: "object",
        properties: {
            description: {
                type: "string",
                description: "A description of the goods and services.",
            },
            goods_and_services: {
                type: "array",
                description: "A list of goods and services offered.",
                items: {
                    type: "string",
                },
            },
        },
        required: ["description", "goods_and_services"],
        additionalProperties: false,
    },
};
export const candidateMetadataSchema = z
    .object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    GSI2_PK: z.string().optional(),
    GSI2_SK: z.string().optional(),
    displayName: z.string(),
    finalizedYears: z.array(z.number()).optional(),
    id: z.string(),
    mailingAddresses: z.array(mailingAddressSchema).optional(),
    modelDescription: modelDescriptionSchema.optional(),
    name: z.string(),
    submitted: z.string().optional(),
    website: z.string().optional(),
})
    .catchall(z.any());
export const verificationAddressSchema = z.object({
    found_on: z.string(),
    address_street: z.string(),
    address_street2: z.string(),
    address_city: z.string(),
    address_region: z.string(),
    address_postal_code: z.string(),
});
//# sourceMappingURL=types.js.map